import { render, staticRenderFns } from "./alipayStoreManage.vue?vue&type=template&id=e0222f32&scoped=true&"
import script from "./alipayStoreManage.vue?vue&type=script&lang=js&"
export * from "./alipayStoreManage.vue?vue&type=script&lang=js&"
import style0 from "./alipayStoreManage.vue?vue&type=style&index=0&id=e0222f32&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0222f32",
  null
  
)

export default component.exports